<template>
  <div id="knowledge">
    <vs-popup title="Remover Métrica Inteligente" :active.sync="openDeletePopUp" @close="openDeletePopUp = false" class="sizePopup">
      <p>Deseja realmente remover o Modelo?</p>

      <div class="w-full d-flex justify-content-flex-end">
        <vs-button color="danger" @click.prevent="remove()">Remover</vs-button>
      </div>
    </vs-popup>

    <div class="flex flex-wrap-reverse items-center">
        <div  @click.prevent="redirectToNew" class="
            p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between
            text-lg font-medium text-base text-primary border border-solid border-primary
        ">
          <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
          <span class="ml-2 text-base text-primary"> Adicionar </span>
        </div>
    </div>

    <vs-table
      search
      pagination
      ref="table"
      noDataText="Nenhum Modelo de Dados do Cliente cadastrado"
      :max-items="itemsPerPage"
      :data="knowledge"
    >
      <template slot="thead">
        <vs-th sort-key="description"> Nome </vs-th>
        <vs-th>Ações</vs-th>
      </template>

      <template slot-scope="{data}">
        <vs-tr :key="idx" v-for="(tr, idx) in data">
          <vs-td :data="tr.description">
            <p> {{ tr.description }} </p>
          </vs-td>

          <vs-td>
            <vs-td class="whitespace-no-wrap">
              <feather-icon
                icon="EditIcon"
                v-if="canSee('update')"
                @click.prevent="redirectToEdit(tr.id)"
                svgClasses="w-5 h-5 hover:text-primary stroke-current"
              />

              <feather-icon
                class="ml-2"
                icon="TrashIcon"
                v-if="canSee('delete')"
                @click.prevent="openModalToDelete(tr)"
                svgClasses="w-5 h-5 hover:text-danger stroke-current"
              />
            </vs-td>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>
<script>
  import requests from '@/http/requests/reasons'
  import { knowledgeType } from "@/supports/reasonSupport";
  import { hasPermission, formatRouteTenantPath } from '@/utils'

  export default {
    name: 'knowledge-list',
    data() {
      return {
        knowledge: [],
        selected: null,
        itemsPerPage: 10,
        openDeletePopUp: false,
      }
    },
    created () { this.loadKnowledge(); },
    methods: {
      canSee(action) {
        return hasPermission(`knowledge-${action}`)
      },
      redirectToNew() {
        this.$router.push(formatRouteTenantPath('/knowledge/add'))
      },
      redirectToEdit(id) {
        this.$router.push(formatRouteTenantPath('/knowledge/edit/' + id))
      },
      loadKnowledge() {
        this.knowledge = [];
        requests.fetch({ deleted:false, type:knowledgeType })
          .then((response) => { this.knowledge = response.data.data.reasons; })
          .catch((error) => { console.error(error) })
      },
      openModalToDelete(selected) {
        this.selected = selected;
        this.openDeletePopUp = true;
      },
      remove() {
        requests.remove(this.selected.id).then(() => {
          this.$vs.notify({
            color: 'success',
            title: 'Sucesso!',
            text: 'O Modelo foi removido com sucesso'
          });

          this.openDeletePopUp = false;
          this.loadKnowledge();
        }).catch((error) => { console.error(error) })
      }
    },
    beforeRouteLeave(to, from, next) {
      if (this.openDeletePopUp) {
        this.openDeletePopUp = false;
        setTimeout( ()=> { next(); }, 2);
      } else { next(); }
    }
  }
</script>
 
<style lang="scss">
#knowledge {
  .select {
    padding: 15px; 
    display:flex; 
    background: #fff;
    border-radius:10px; 
    text-align:center;
    flex-direction: column; 
    border: 1px solid rgba(0, 0, 0, 0.2);
  }

  .vs-table {
    border-collapse: separate;
    border-spacing: 0 0.7rem;
    padding: 0 1rem;

    tr{
      box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
      td{
        padding: 10px;
      }
    }
  }

  .vs-table--thead{
    th {
      
      padding-top: 0;
      padding-bottom: 0;

      .vs-table-text{
        text-transform: uppercase;
        font-weight: 600;
        
      }
    }
    tr{
      background: none;
      box-shadow: none;
    }
  }

  .vs-table--pagination {
    justify-content: center;
  }
}
</style>
